import React from 'react';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import RadioButtonUncheckedOutlinedIcon from '@mui/icons-material/RadioButtonUncheckedOutlined';

const getStatusConfig = (rowData) => {
  if (rowData?.department_rejected) {
    return {
      label: 'Declined',
      color: '#c62828',
      Icon: BlockOutlinedIcon,
      tooltip:
        rowData?.department_rejection_comment ||
        'This tender was declined for your department.',
    };
  }

  if (rowData?.regionalStatus) {
    return {
      label: 'Prices Set',
      color: '#2e7d32',
      Icon: CheckCircleOutlineOutlinedIcon,
      tooltip: 'Pricing is already completed for your department.',
    };
  }

  return {
    label: 'Open',
    color: '#757575',
    Icon: RadioButtonUncheckedOutlinedIcon,
    tooltip: 'This tender still needs action from your department.',
  };
};

const TenderActionStatusCellRenderer = ({ data }) => {
  const statusConfig = getStatusConfig(data);
  const { Icon } = statusConfig;

  return (
    <Tooltip title={statusConfig.tooltip} placement="right">
      <Stack direction="row" spacing={0.75} alignItems="center" sx={ { height: "100%", justifyContent: "center" } }>
        <Icon sx={{ color: statusConfig.color }} fontSize="small" />
        <Typography
          variant="body2"
          sx={{ color: statusConfig.color, fontWeight: 600 }}
        >
          {statusConfig.label}
        </Typography>
      </Stack>
    </Tooltip>
  );
};

export default TenderActionStatusCellRenderer;
